// extracted by mini-css-extract-plugin
export default {"noDataView":"NoDataView_noDataView__lv-Ag","icon":"NoDataView_icon__yrr1j","message":"NoDataView_message__U4TXa","messageDetail":"NoDataView_messageDetail__9ZTzf"};